import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';

export function AuthLayout() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-teal-600 border-t-transparent" />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex min-h-screen">
      {/* Left side - Image */}
      <div className="hidden w-1/2 lg:block relative">
        <img
          src="https://images.unsplash.com/photo-507874-hot-air-balloons-flying?w=1200"
          alt="Hot air balloons"
          className="w-full h-full object-cover"
          onError={(e) => {
            // Fallback to gradient if image fails
            e.currentTarget.style.display = 'none';
            e.currentTarget.parentElement!.classList.add('bg-gradient-to-br', 'from-teal-400', 'to-teal-600');
          }}
        />
        {/* Gradient overlay fallback */}
        <div className="absolute inset-0 bg-gradient-to-br from-teal-400/80 to-teal-600/80" />
      </div>

      {/* Right side - auth form */}
      <div className="flex w-full items-center justify-center p-8 lg:w-1/2 bg-white">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
